import React from 'react'
import { BiLoaderAlt } from 'react-icons/bi'

const Button: React.FC<ButtonProps> = ({
  idForm,
  icon,
  type = 'default',
  onClick,
  loading,
  danger,
  small = false,
  htmlType = 'button',
  disabled,
  classes,
  children,
  ref,
  style,
  isIconLeft = true,
  warehouseType,
  textStyle = undefined
}) => {
  const typeStyles: () => string = () => {
    switch (type) {
      case 'primary':
        return `text-white border-none dark:text-white dark:hover:text-white dark:focus:text-white hover:text-white focus:text-white ${
          danger
            ? 'bg-gradient-to-tr from-red-600 to-danger dark:bg-danger-dark dark:hover:bg-danger focus:bg-danger dark:focus:bg-danger'
            : ' bg-gradient-to-bl from-primary to-primary-dark dark:hover:bg-primary focus:bg-primary dark:focus:bg-primary'
        } hover:bg-opacity-90`
      case 'link':
        return `border-none`
      case 'dashed':
        return `border-dashed`
      case 'outline':
        return `${danger ? 'border-danger' : 'border-primary'} ${
          danger ? 'text-danger' : 'text-primary'
        } ${
          danger ? 'dark:border-danger' : 'dark:border-primary'
        }  dark:text-primary  bg-transparent`
      case 'arrow':
        return `${
          warehouseType === 'SALE FLOOR'
            ? 'dark:text-primaryGreen-300 text-primaryGreen-500'
            : warehouseType === 'WAREHOUSE'
            ? 'dark:text-primary text-primary'
            : 'text-primaryOrange-dark dark:text-primaryOrange'
        }`
      default:
        return ''
    }
  }

  return (
    <button
      ref={ref}
      form={idForm}
      type={htmlType}
      disabled={loading || disabled}
      onClick={onClick}
      style={style}
      className={`${!children && 'px-1.5'} flex flex-nowrap items-stretch ${
        (loading || disabled) && 'cursor-not-allowed '
      } ${classes} ${small && 'h-inputSmall rounded'} ${typeStyles()} 
    ${
      danger &&
      'hover:border-danger dark:hover:border-danger-dark focus:border-danger dark:focus:border-danger-dark hover:text-danger focus:text-danger dark:focus:text-danger-danger dark:hover:text-danger-dark dark:focus:text-danger-dark'
    }
    ${
      disabled &&
      'from-gray-200 to-gray-200 bg-gray-200 dark:bg-gray-800 dark:text-gray-600 dark:border-gray-600 '
    }`}
    >
      {(loading || icon) && isIconLeft && (
        <span className="text-sm flex items-center" style={{ marginTop: 1 }}>
          {loading ? <BiLoaderAlt className="animate-spin" /> : icon}
        </span>
      )}
      {children && (
        <p className={`ml-1.5 font-medium tracking-wide flex flex-grow items-center justify-center`} style={textStyle}>
          {children}
        </p>
      )}
      {!isIconLeft && (
        <span
          className="text-sm flex items-center ml-1.5"
          style={{ marginTop: 1 }}
        >
          {icon}
        </span>
      )}
    </button>
  )
}

export default Button

interface ButtonProps {
  disabled?: boolean
  type?: ButtonType
  small?: boolean
  classes?: string
  icon?: React.ReactElement
  htmlType?: 'submit' | 'button' | 'reset'
  danger?: boolean
  loading?: boolean
  idForm?: string
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void
  ref?: React.MutableRefObject<any>
  style?: React.CSSProperties
  isIconLeft?: boolean
  warehouseType?: string
  textStyle?: React.CSSProperties | undefined
}


export type ButtonType = 'default' | 'primary' | 'link' | 'dashed' | 'outline' | 'arrow'